import React, { Component } from 'react';
import { login, LOGIN_FAIL } from '../../redux/modules/auth';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';

const EMAIL_FAILED = 'This email is not registered.';
const PASSWORD_FAIL = 'This password is not correct.';
const EMAIL = 'email';
const PASSWORD = 'password';

@connect(
  ({ boligagents: { sessionPrefs } }) => ({ sessionPrefs }),
  { login }
)
@i18n
class NavUserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false
    };
  }

  componentWillUnmount() {
    this.setState({ error: null });
  }

  getErrMsg(obj) {
    const object = {
      [EMAIL_FAILED]: EMAIL,
      [PASSWORD_FAIL]: PASSWORD
    };

    if (obj && obj.info && obj.info.message) {
      return object[obj.info.message] || null;
    }
    return null;
  }

  handleSubmit = event => {
    event.preventDefault();

    const { login, sessionPrefs } = this.props;

    const email = this.refs.email.value;
    const password = this.refs.password.value;

    if (!email) {
      return this.setState({ error: EMAIL });
    }
    if (!password) {
      return this.setState({ error: PASSWORD });
    }

    this.setState({ loading: true });

    login({ email, password, prefs: sessionPrefs }).then(action => {
      if (action.type === LOGIN_FAIL) {
        const {
          error: { response }
        } = action;
        this.setState({ loading: false, error: this.getErrMsg(response) });
      }
      return action;
    });
  };

  render() {
    const { error, loading } = this.state;
    return (
      <form onSubmit={this.handleSubmit} name="form" autoComplete="on">
        <div
          type="email"
          name="email"
          placeholder={this.i18n('Email address')}
          className={`form-group${
            error === EMAIL ? ' form-group-error has-error' : ''
          }`}
        >
          <div className="input-group">
            <span className="input-group-addon" style={{ padding: 6 }}>
              <i className="fa fa-fw fa-at" />
            </span>
            <input
              ref="email"
              type="email"
              name="email"
              placeholder={this.i18n('Email address')}
              className="form-control"
            />
          </div>
          {/* <span className={`${error === EMAIL ? 'glyphicon glyphicon-remove ' : ''}form-control-feedback`} /> */}
        </div>

        <div
          type="password"
          name="password"
          placeholder={this.i18n('Password')}
          className={`form-group${
            error === PASSWORD ? ' form-group-error has-error' : ''
          }`}
        >
          <div className="input-group">
            <span className="input-group-addon" style={{ padding: 6 }}>
              <i className="fa fa-fw fa-key" />
            </span>
            <input
              ref="password"
              type="password"
              name="password"
              placeholder={this.i18n('Password')}
              className="form-control"
            />
          </div>
          {/* <span className={`${error === PASSWORD ? 'glyphicon glyphicon-remove ' : ''}form-control-feedback`} /> */}
        </div>

        <div className="form-group">
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary btn-block"
          >
            <i className="fa fa-unlock" />
            {this.i18n('Login')}
          </button>
        </div>
      </form>
    );
  }
}

export default NavUserLogin;
